import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { SettingsPanel, SettingsSection, SettingsAction } from "../Settings";

const SecuritySettings = ({
    passwordSet,
    passwordActionBusy,
    onChangePassword,
    onSetPassword,
    onManageSessions,
}) => {
    const { t } = useTranslation();
    const hasMuzonePassword = passwordSet !== false;
    const passwordAction = hasMuzonePassword
        ? {
            label: t("profile.security.actions.passwordLabel"),
            description: t("profile.security.actions.passwordDescription"),
            buttonLabel: t("profile.security.actions.passwordButton"),
            onClick: onChangePassword,
        }
        : {
            label: t("profile.security.actions.setPasswordLabel"),
            description: t("profile.security.actions.setPasswordDescription"),
            buttonLabel: t("profile.security.actions.setPasswordButton"),
            onClick: onSetPassword,
        };

    return (
        <SettingsPanel
            title={t("profile.security.panelTitle")}
            description={t("profile.security.panelDescription")}
        >
            <SettingsSection
                title={t("profile.security.sections.twoFactorTitle")}
                description={t("profile.security.sections.twoFactorDescription")}
            >
                <div className="settings-option" role="note">
                    <div className="settings-option__details">
                        <span className="settings-option__label">
                            {t("profile.security.serverManaged.label")}
                        </span>
                        <span className="settings-option__description">
                            {t("profile.security.serverManaged.description")}
                        </span>
                    </div>
                </div>
            </SettingsSection>

            <SettingsSection
                title={t("profile.security.sections.passwordTitle")}
                description={t("profile.security.sections.passwordDescription")}
            >
                <SettingsAction
                    label={passwordAction.label}
                    description={passwordAction.description}
                    buttonLabel={passwordAction.buttonLabel}
                    buttonVariant="primary"
                    onClick={passwordAction.onClick}
                    disabled={passwordActionBusy}
                />
            </SettingsSection>

            <SettingsSection
                title={t("profile.security.sections.sessionsTitle")}
                description={t("profile.security.sections.sessionsDescription")}
            >
                <SettingsAction
                    label={t("profile.security.actions.sessionsLabel")}
                    description={t("profile.security.actions.sessionsDescription")}
                    buttonLabel={t("profile.security.actions.sessionsButton")}
                    buttonVariant="primary"
                    onClick={onManageSessions}
                />
            </SettingsSection>
        </SettingsPanel>
    );
};

SecuritySettings.propTypes = {
    passwordSet: PropTypes.bool,
    passwordActionBusy: PropTypes.bool,
    onChangePassword: PropTypes.func,
    onSetPassword: PropTypes.func,
    onManageSessions: PropTypes.func,
};

SecuritySettings.defaultProps = {
    passwordSet: true,
    passwordActionBusy: false,
    onChangePassword: () => {},
    onSetPassword: () => {},
    onManageSessions: () => {},
};

export default SecuritySettings;
